import Modal from 'react-modal';
import {motion} from 'motion/react'
import { IoClose } from "react-icons/io5";
import { useEffect } from "react";

import Alfredo from '../../assets/imagens/Alfredo.png'


import './Modais.css'
export default function DefaultModal ({modalIsOpen, closeModal, children, sound}){
    var audio = ''

    const emitirSom = ()=>{
       switch(sound){
        case "timeout":
            audio = new Audio('/sounds/timeout.mp3')
            audio.play().catch(error => console.log("Não foi possível reproduzir este audio: ", error))
        case "positive":
            audio = new Audio('/sounds/positive.mp3')
            audio.play().catch(error => console.log("Não foi possível reproduzir este audio: ", error))
        default:
            audio = new Audio('/sounds/popUp3.mp3')
            audio.play().catch(error => console.log("Não foi possível reproduzir este audio: ", error)) 
       }
    }

    return(
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            className='ModalIniciar'
            overlayClassName="overlayModal"
            onAfterOpen={emitirSom}
            >
            <div className='containerModalIniciar'>
                     <div className='flex'>
                        <img className='avatarAlfredo' width={200} src={Alfredo} />
                        <div className='areaTexto'>
                           <div>
                                {children}
                           </div>

                            <motion.button 
                                whileHover={{scale:1.1}}
                                className="btn btnAmarelo"
                                onClick={()=>closeModal()}
                                >
                                Seguir
                            </motion.button>
                        </div>
                    </div>
            </div>
        </Modal>
    )
    
}